export const ORDER_PATHS = {
  setup: '/order/setup',
  menu: '/order/menu',
  product: '/order/product',
  review: '/order/review',
  confirmation: '/order/confirmation',
} as const;

export function productPath(itemId: number): string {
  return `${ORDER_PATHS.product}?itemId=${encodeURIComponent(itemId)}`;
}

export function confirmationPath(retrievalCode: string): string {
  return `${ORDER_PATHS.confirmation}?code=${encodeURIComponent(retrievalCode)}`;
}
